/* MS Belts — shared site behavior (Shopify build) */

(function () {
  // ===== Reveal on scroll =====
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach((el) => io.observe(el));
    // Failsafe: if anything is still hidden after 2s, reveal it
    setTimeout(() => {
      document.querySelectorAll('.reveal:not(.is-in)').forEach(el => el.classList.add('is-in'));
    }, 2200);
  } else {
    reveals.forEach(el => el.classList.add('is-in'));
  }

  // ===== Cart drawer =====
  const cartBtn = document.querySelector('[data-cart-toggle]');
  const drawer  = document.querySelector('[data-cart-drawer]');
  const closeBtn = document.querySelector('[data-cart-close]');
  const overlay = document.querySelector('[data-cart-overlay]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  cartBtn && cartBtn.addEventListener('click', openCart);
  closeBtn && closeBtn.addEventListener('click', closeCart);
  overlay && overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  // ===== Cart counter — real Shopify cart =====
  // Store is USD-only; format cents as $X.XX (trim trailing .00)
  function money(cents) {
    const v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + v;
  }

  function setCartCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
  }

  function renderDrawer(cart) {
    const body = document.querySelector('[data-cart-items]');
    if (!body) return;
    body.classList.toggle('has-items', !!cart && cart.item_count > 0);
    if (!cart || cart.item_count === 0) {
      body.innerHTML =
        '<div style="font-family:var(--font-serif);font-style:italic;font-size:28px;color:var(--gold-500);">empty.</div>' +
        '<p>Your roster is empty. Browse the championship roster and crown yourself.</p>' +
        '<a href="/collections/all" class="btn btn--gold btn--sm btn--arrow" style="margin-top:8px;">Shop the Roster</a>';
      return;
    }
    const items = cart.items.map((item, i) =>
      '<div class="cart-drawer__item">' +
        (item.image
          ? '<img class="cart-drawer__item-img" src="' + item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy"/>'
          : '<span class="cart-drawer__item-img"></span>') +
        '<div class="cart-drawer__item-info">' +
          '<a class="cart-drawer__item-title" href="' + item.url + '">' + item.product_title + '</a>' +
          '<div class="cart-drawer__item-meta">' + item.quantity + ' × ' + money(item.final_price) + '</div>' +
        '</div>' +
        '<button class="cart-drawer__item-remove" type="button" data-cart-remove data-line="' + (i + 1) + '" aria-label="Remove">×</button>' +
      '</div>'
    ).join('');
    body.innerHTML =
      '<div class="cart-drawer__items">' + items + '</div>' +
      '<div class="cart-drawer__foot">' +
        '<div class="cart-drawer__subtotal"><span>Subtotal</span><strong>' + money(cart.items_subtotal_price) + '</strong></div>' +
        '<a href="/cart" class="btn btn--ghost btn--sm btn--block">View Cart</a>' +
        '<a href="/checkout" class="btn btn--gold btn--sm btn--block">Checkout</a>' +
      '</div>';
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        setCartCount(cart.item_count);
        renderDrawer(cart);
        return cart;
      })
      .catch(() => {});
  }
  refreshCart();

  // ===== Add to cart — Shopify AJAX Cart API =====
  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then((r) => {
      if (!r.ok) return r.json().then((e) => Promise.reject(e));
      return r.json();
    });
  }

  // Wire any add-to-cart button: reads variant id from the closest form
  // (input[name="id"]) or from a data-variant-id attribute on the element.
  document.querySelectorAll('[data-add-cart]').forEach((b) => {
    b.addEventListener('click', (e) => {
      const form = b.closest('form');
      const idInput = form && form.querySelector('input[name="id"]');
      const variantId = (idInput && idInput.value) || b.dataset.variantId;
      if (!variantId) return; // no variant on this element — allow default behavior
      e.preventDefault();
      const qtyInput = form && form.querySelector('[name="quantity"]');
      const quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      b.classList.add('is-loading');
      addToCart(variantId, quantity)
        .then(() => refreshCart())
        .then(() => openCart())
        .catch((err) => {
          window.alert((err && err.description) || 'Could not add to cart.');
        })
        .finally(() => b.classList.remove('is-loading'));
    });
  });

  // Remove line items from the drawer (event delegation — drawer re-renders)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(btn.dataset.line, 10), quantity: 0 })
    })
      .then((r) => r.json())
      .then((cart) => {
        setCartCount(cart.item_count);
        renderDrawer(cart);
      })
      .catch(() => {});
  });

  // ===== Mobile nav =====
  const menuBtn   = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  function openMenu()  { mobileNav && mobileNav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeMenu() { mobileNav && mobileNav.classList.remove('is-open'); document.body.style.overflow = ''; }
  menuBtn && menuBtn.addEventListener('click', openMenu);
  menuClose && menuClose.addEventListener('click', closeMenu);
  mobileNav && mobileNav.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMenu));

  // ===== Apply persisted theme tweaks =====
  try {
    const t = JSON.parse(localStorage.getItem('ms_tweaks') || 'null');
    if (t && typeof t === 'object') {
      const r = document.documentElement;
      if (t.palette === 'blood') {
        r.style.setProperty('--gold-500', '#d4af37');
        r.style.setProperty('--ink-900', '#1a0505');
        r.style.setProperty('--ink-850', '#220707');
        r.style.setProperty('--ink-800', '#2a0909');
        r.style.setProperty('--ink-700', '#3a0c0c');
      } else if (t.palette === 'bone') {
        r.style.setProperty('--ink-900', '#f5efe2');
        r.style.setProperty('--ink-850', '#ede6d5');
        r.style.setProperty('--ink-800', '#e3dac6');
        r.style.setProperty('--bone-100', '#0a0807');
        r.style.setProperty('--bone-200', '#2a2218');
        r.style.setProperty('--bone-300', '#5a4d34');
        r.style.setProperty('--rule', 'rgba(10,8,7,0.12)');
      }
      if (t.headFont === 'bebas') {
        r.style.setProperty('--font-display', '"Bebas Neue", "Anton", sans-serif');
      } else if (t.headFont === 'condensed') {
        r.style.setProperty('--font-display', '"Big Shoulders Display", "Anton", sans-serif');
      }
    }
  } catch (_) {}
})();
